import { supabase } from './supabase.js';

/**
 * Fetch the user's full profile from the public.users table.
 * (auth.users only contains email + auth metadata; the rest is in public.users)
 */
export async function fetchProfile(userId) {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();
  if (error) {
    console.error('Failed to fetch profile:', error);
    return null;
  }
  return data;
}

/**
 * Update fields on the user's profile.
 */
export async function updateProfile(userId, updates) {
  const { data, error } = await supabase
    .from('users')
    .update(updates)
    .eq('id', userId)
    .select()
    .single();
  if (error) throw error;
  return data;
}
